function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module))) module.exports = t(require("react"));else if ("function" == typeof define && define.amd) define(["react"], t);else {
    var n = t("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("react") : e.React);

    for (var r in n) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[r] = n[r];
    }
  }
}(this, function (e) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.i = function (e) {
      return e;
    }, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 8);
  }([function (e, t) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }

    function r() {
      throw new Error("clearTimeout has not been defined");
    }

    function o(e) {
      if (l === setTimeout) return setTimeout(e, 0);
      if ((l === n || !l) && setTimeout) return l = setTimeout, setTimeout(e, 0);

      try {
        return l(e, 0);
      } catch (t) {
        try {
          return l.call(null, e, 0);
        } catch (t) {
          return l.call(this, e, 0);
        }
      }
    }

    function i(e) {
      if (f === clearTimeout) return clearTimeout(e);
      if ((f === r || !f) && clearTimeout) return f = clearTimeout, clearTimeout(e);

      try {
        return f(e);
      } catch (t) {
        try {
          return f.call(null, e);
        } catch (t) {
          return f.call(this, e);
        }
      }
    }

    function a() {
      v && h && (v = !1, h.length ? d = h.concat(d) : y = -1, d.length && u());
    }

    function u() {
      if (!v) {
        var e = o(a);
        v = !0;

        for (var t = d.length; t;) {
          for (h = d, d = []; ++y < t;) {
            h && h[y].run();
          }

          y = -1, t = d.length;
        }

        h = null, v = !1, i(e);
      }
    }

    function s(e, t) {
      this.fun = e, this.array = t;
    }

    function c() {}

    var l,
        f,
        p = e.exports = {};
    !function () {
      try {
        l = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        l = n;
      }

      try {
        f = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (e) {
        f = r;
      }
    }();
    var h,
        d = [],
        v = !1,
        y = -1;
    p.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      d.push(new s(e, t)), 1 !== d.length || v || o(u);
    }, s.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = c, p.addListener = c, p.once = c, p.off = c, p.removeListener = c, p.removeAllListeners = c, p.emit = c, p.prependListener = c, p.prependOnceListener = c, p.listeners = function (e) {
      return [];
    }, p.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, p.cwd = function () {
      return "/";
    }, p.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, p.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var o = function o() {};

    o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      function n(e, t, n, o, i, a, u, s) {
        if (r(t), !e) {
          var c;
          if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var l = [n, o, i, a, u, s],
                f = 0;
            c = new Error(t.replace(/%s/g, function () {
              return l[f++];
            })), c.name = "Invariant Violation";
          }
          throw c.framesToPop = 1, c;
        }
      }

      var r = function r(e) {};

      "production" !== t.env.NODE_ENV && (r = function r(e) {
        if (void 0 === e) throw new Error("invariant requires an error message argument");
      }), e.exports = n;
    }).call(t, n(0));
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      var r = n(1),
          o = r;
      "production" !== t.env.NODE_ENV && function () {
        var e = function e(_e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
            n[r - 1] = arguments[r];
          }

          var o = 0,
              i = "Warning: " + _e.replace(/%s/g, function () {
            return n[o++];
          });

          "undefined" != typeof console && console.error(i);

          try {
            throw new Error(i);
          } catch (e) {}
        };

        o = function o(t, n) {
          if (void 0 === n) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");

          if (0 !== n.indexOf("Failed Composite propType: ") && !t) {
            for (var r = arguments.length, o = Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) {
              o[i - 2] = arguments[i];
            }

            e.apply(void 0, [n].concat(o));
          }
        };
      }(), e.exports = o;
    }).call(t, n(0));
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        i = function () {
      function e() {
        r(this, e), this._separator = ".", this._integer = 10, this._fraction = 10, this._positive = !0, this._negative = !0, this._regexp = this._buildRegexp(), this._isThousand = !1, this._thousand = null;
      }

      return o(e, [{
        key: "clone",
        value: function value() {
          var t = new e();
          return t._separator = this._separator, t._integer = this._integer, t._fraction = this._fraction, t._positive = this._positive, t._negative = this._negative, t._regexp = this._regexp, t._isThousand = this._isThousand, t._thousand = this._thousand, t._cursor = this._cursor, t;
        }
      }, {
        key: "calculateViewFromModel",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
          return this._createViewValueFromModel(e);
        }
      }, {
        key: "calculate",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "0",
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
          this._rawViewValue = e, this._oldModelValue = t, this._oldViewValue = n, this._newModelValue = 0, this._newViewValue = "", this._cursor = r;
          var o = String(this._rawViewValue);
          return o = this._removeThousandSeparator(o), o = this._removeLeadingZero(o), "" === o && "0" === String(this._rawViewValue).charAt(0) ? (this._newModelValue = 0, void (this._newViewValue = "0")) : void 0 === o || "" === o ? (this._newModelValue = 0, void (this._newViewValue = "")) : "-" === o ? (this._newModelValue = 0, void (this._newViewValue = "-")) : !1 === this._regexp.test(o) ? (this._newModelValue = this._oldModelValue, void (this._newViewValue = this._oldViewValue)) : (this._newModelValue = this._createModelValueFromView(o), this._newViewValue = this._createViewValueFromView(o), void (this._cursor = this._calculateNewCursorPosition()));
        }
      }, {
        key: "_calculateThousandSeparator",
        value: function value() {
          " " !== this._thousand && ("." === this._separator ? this._thousand = "," : this._thousand = ".");
        }
      }, {
        key: "_calculateNewCursorPosition",
        value: function value() {
          var e = String(this._rawViewValue).slice(0, this._cursor);
          e = this._removeThousandSeparator(e), e = this._removeLeadingZero(e);
          var t = e.length;

          if (this._isThousand) {
            var n = 0,
                r = 0,
                o = void 0,
                i = this._newViewValue.length;

            for (o = 0; o < i; o++) {
              if (this._newViewValue[o] !== this._thousand) {
                if (++n >= t) break;
              } else r++;
            }

            t += r;
          }

          return t;
        }
      }, {
        key: "_buildRegexp",
        value: function value() {
          var e = "-?";
          !1 === this._positive && !0 === this._negative ? e = "-" : !0 === this._positive && !1 === this._negative && (e = "");
          var t = "[0-9]{0," + this._integer + "}";
          0 === this._integer && (t = "0");
          var n = "(\\" + this._separator + "([0-9]){0," + this._fraction + "})";
          return 0 === this._fraction && (n = ""), new RegExp("^" + e + t + n + "?$");
        }
      }, {
        key: "_removeLeadingZero",
        value: function value(e) {
          return e.replace(/^0+/g, "").replace(/^-0(\d+)/g, "-$1").replace(/^-([\.,])/, "-0$1").replace(/^[\.,]/g, "0$&");
        }
      }, {
        key: "_removeThousandSeparator",
        value: function value(e) {
          return this._isThousand ? e.replace(new RegExp("\\" + this._thousand, "g"), "") : e;
        }
      }, {
        key: "_createModelValueFromView",
        value: function value(e) {
          return "," === this._separator ? parseFloat(e.replace(/\./g, "").replace(",", ".")) : parseFloat(e.replace(/,/g, ""));
        }
      }, {
        key: "_createViewValueFromView",
        value: function value(e) {
          return this._isThousand ? (e = e.split(this._separator), e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, this._thousand), e.join(this._separator)) : e;
        }
      }, {
        key: "_createViewValueFromModel",
        value: function value(e) {
          var t = String(e);
          return this._isThousand ? (t = t.split("."), t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, this._thousand), t.join(this._separator)) : t.replace(/\./g, this._separator);
        }
      }, {
        key: "separator",
        set: function set(e) {
          this._separator = "." === e || "," === e ? e : this._separator, this._regexp = this._buildRegexp(), this._calculateThousandSeparator();
        }
      }, {
        key: "integer",
        set: function set(e) {
          if (e >= 0) {
            var t = parseInt(e, 10);
            !1 === isNaN(t) && isFinite(t) && t >= 0 && (this._integer = t);
          }

          this._regexp = this._buildRegexp();
        }
      }, {
        key: "fraction",
        set: function set(e) {
          if (e >= 0) {
            var t = parseInt(e, 10);
            !1 === isNaN(t) && isFinite(t) && t >= 0 && (this._fraction = t);
          }

          this._regexp = this._buildRegexp();
        }
      }, {
        key: "positive",
        set: function set(e) {
          !0 !== e && !1 !== e || (this._positive = e), this._regexp = this._buildRegexp();
        }
      }, {
        key: "negative",
        set: function set(e) {
          !0 !== e && !1 !== e || (this._negative = e), this._regexp = this._buildRegexp();
        }
      }, {
        key: "thousand",
        set: function set(e) {
          this._isThousand = e || " " === e, " " === e && (this._thousand = " "), this._calculateThousandSeparator();
        }
      }, {
        key: "modelValue",
        get: function get() {
          return this._newModelValue;
        }
      }, {
        key: "viewValue",
        get: function get() {
          return this._newViewValue;
        }
      }, {
        key: "cursorPosition",
        get: function get() {
          return this._cursor;
        }
      }]), e;
    }();

    t.default = i;
  }, function (e, t, n) {
    (function (t) {
      if ("production" !== t.env.NODE_ENV) {
        var r = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103,
            o = function o(e) {
          return "object" == _typeof(e) && null !== e && e.$$typeof === r;
        };

        e.exports = n(11)(o, !0);
      } else e.exports = n(10)();
    }).call(t, n(0));
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e, t) {
      var n = {};

      for (var r in e) {
        t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      }

      return n;
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    function u(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        c = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        l = n(7),
        f = r(l),
        p = n(6),
        h = r(p),
        d = n(5),
        v = r(d),
        y = function (e) {
      function t(e) {
        i(this, t);
        var n = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return n.dynamicNumber = new v.default(), n.dynamicNumber.separator = n.props.separator, n.dynamicNumber.integer = n.props.integer, n.dynamicNumber.fraction = n.props.fraction, n.dynamicNumber.positive = n.props.positive, n.dynamicNumber.negative = n.props.negative, n.dynamicNumber.thousand = n.props.thousand, n.calculator = n.dynamicNumber.clone(), n.calculator.calculate(n.calculator.calculateViewFromModel(e.value), e.value, "0"), n.state = {
          modelValue: n.calculator.modelValue,
          viewValue: n.calculator.viewValue
        }, n.onChange = n.onChange.bind(n), n.focus = n.focus.bind(n), n;
      }

      return u(t, e), c(t, [{
        key: "focus",
        value: function value() {
          this.input && this.input.focus && this.input.focus();
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          "" === e.value ? this.setState({
            modelValue: "",
            viewValue: ""
          }) : void 0 !== e.value && (this.calculator.calculate(this.calculator.calculateViewFromModel(e.value), e.value, "0"), this.setState({
            modelValue: this.calculator.modelValue,
            viewValue: this.calculator.viewValue
          }));
        }
      }, {
        key: "getCaretPosition",
        value: function value(e) {
          var t = 0;

          if (document.selection) {
            e.focus();
            var n = document.selection.createRange();
            n.moveStart("character", -e.value.length), t = n.text.length;
          } else (e.selectionStart || 0 === Number(e.selectionStart)) && (t = "backward" === e.selectionDirection ? e.selectionStart : e.selectionEnd);

          return t;
        }
      }, {
        key: "onChange",
        value: function value(e) {
          var t = this,
              n = e.target;
          this.dynamicNumber.calculate(e.target.value, this.state.modelValue, this.state.viewValue, this.getCaretPosition(n));
          var r = this.dynamicNumber.modelValue,
              o = this.dynamicNumber.viewValue;
          this.props.onChange && this.props.onChange(e, r, o), this.setState({
            modelValue: r,
            viewValue: o
          }, function () {
            void 0 !== n.selectionStart && null !== n.selectionStart && (n.selectionStart = n.selectionEnd = t.dynamicNumber.cursorPosition);
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = (t.separator, t.integer, t.fraction, t.positive, t.negative, t.thousand, o(t, ["separator", "integer", "fraction", "positive", "negative", "thousand"]));
          return f.default.createElement("input", s({
            type: "text",
            ref: function ref(t) {
              e.input = t;
            },
            placeholder: this.props.placeholder,
            className: this.props.className
          }, n, {
            value: this.state.viewValue,
            onChange: this.onChange
          }));
        }
      }]), t;
    }(f.default.Component);

    y.propTypes = {
      value: h.default.oneOfType([h.default.number, function (e, t) {
        if ("" !== e[t]) return new Error("value must be a number or empty string");
      }]),
      integer: h.default.number,
      fraction: h.default.number,
      positive: h.default.bool,
      negative: h.default.bool,
      separator: function separator(e, t) {
        if (void 0 !== e[t] && "," !== e[t] && "." !== e[t]) return new Error("separator have to be comma or dot char");
      },
      thousand: function thousand(e, t) {
        if (void 0 !== e[t] && !0 !== e[t] && !1 !== e[t] && " " !== e[t]) return new Error("thousand have to be bool value or space character");
      }
    }, t.default = y;
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      function r(e, n, r, s, c) {
        if ("production" !== t.env.NODE_ENV) for (var l in e) {
          if (e.hasOwnProperty(l)) {
            var f;

            try {
              o("function" == typeof e[l], "%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.", s || "React class", r, l), f = e[l](n, l, s, r, null, a);
            } catch (e) {
              f = e;
            }

            if (i(!f || f instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s || "React class", r, l, _typeof(f)), f instanceof Error && !(f.message in u)) {
              u[f.message] = !0;
              var p = c ? c() : "";
              i(!1, "Failed %s type: %s%s", r, f.message, null != p ? p : "");
            }
          }
        }
      }

      if ("production" !== t.env.NODE_ENV) var o = n(2),
          i = n(3),
          a = n(4),
          u = {};
      e.exports = r;
    }).call(t, n(0));
  }, function (e, t, n) {
    "use strict";

    var r = n(1),
        o = n(2);

    e.exports = function () {
      function e() {
        o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      var r = n(1),
          o = n(2),
          i = n(3),
          a = n(4),
          u = n(9);

      e.exports = function (e, n) {
        function s(e) {
          var t = e && (x && e[x] || e[O]);
          if ("function" == typeof t) return t;
        }

        function c(e, t) {
          return e === t ? 0 !== e || 1 / e == 1 / t : e !== e && t !== t;
        }

        function l(e) {
          this.message = e, this.stack = "";
        }

        function f(e) {
          function r(r, c, f, p, h, d, v) {
            if (p = p || E, d = d || f, v !== a) if (n) o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if ("production" !== t.env.NODE_ENV && "undefined" != typeof console) {
              var y = p + ":" + f;
              !u[y] && s < 3 && (i(!1, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", d, p), u[y] = !0, s++);
            }
            return null == c[f] ? r ? new l(null === c[f] ? "The " + h + " `" + d + "` is marked as required in `" + p + "`, but its value is `null`." : "The " + h + " `" + d + "` is marked as required in `" + p + "`, but its value is `undefined`.") : null : e(c, f, p, h, d);
          }

          if ("production" !== t.env.NODE_ENV) var u = {},
              s = 0;
          var c = r.bind(null, !1);
          return c.isRequired = r.bind(null, !0), c;
        }

        function p(e) {
          function t(t, n, r, o, i, a) {
            var u = t[n];
            if (b(u) !== e) return new l("Invalid " + o + " `" + i + "` of type `" + V(u) + "` supplied to `" + r + "`, expected `" + e + "`.");
            return null;
          }

          return f(t);
        }

        function h(e) {
          function t(t, n, r, o, i) {
            if ("function" != typeof e) return new l("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
            var u = t[n];

            if (!Array.isArray(u)) {
              return new l("Invalid " + o + " `" + i + "` of type `" + b(u) + "` supplied to `" + r + "`, expected an array.");
            }

            for (var s = 0; s < u.length; s++) {
              var c = e(u, s, r, o, i + "[" + s + "]", a);
              if (c instanceof Error) return c;
            }

            return null;
          }

          return f(t);
        }

        function d(e) {
          function t(t, n, r, o, i) {
            if (!(t[n] instanceof e)) {
              var a = e.name || E;
              return new l("Invalid " + o + " `" + i + "` of type `" + T(t[n]) + "` supplied to `" + r + "`, expected instance of `" + a + "`.");
            }

            return null;
          }

          return f(t);
        }

        function v(e) {
          function n(t, n, r, o, i) {
            for (var a = t[n], u = 0; u < e.length; u++) {
              if (c(a, e[u])) return null;
            }

            return new l("Invalid " + o + " `" + i + "` of value `" + a + "` supplied to `" + r + "`, expected one of " + JSON.stringify(e) + ".");
          }

          return Array.isArray(e) ? f(n) : ("production" !== t.env.NODE_ENV && i(!1, "Invalid argument supplied to oneOf, expected an instance of array."), r.thatReturnsNull);
        }

        function y(e) {
          function t(t, n, r, o, i) {
            if ("function" != typeof e) return new l("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
            var u = t[n],
                s = b(u);
            if ("object" !== s) return new l("Invalid " + o + " `" + i + "` of type `" + s + "` supplied to `" + r + "`, expected an object.");

            for (var c in u) {
              if (u.hasOwnProperty(c)) {
                var f = e(u, c, r, o, i + "." + c, a);
                if (f instanceof Error) return f;
              }
            }

            return null;
          }

          return f(t);
        }

        function m(e) {
          function n(t, n, r, o, i) {
            for (var u = 0; u < e.length; u++) {
              if (null == (0, e[u])(t, n, r, o, i, a)) return null;
            }

            return new l("Invalid " + o + " `" + i + "` supplied to `" + r + "`.");
          }

          return Array.isArray(e) ? f(n) : ("production" !== t.env.NODE_ENV && i(!1, "Invalid argument supplied to oneOfType, expected an instance of array."), r.thatReturnsNull);
        }

        function _(e) {
          function t(t, n, r, o, i) {
            var u = t[n],
                s = b(u);
            if ("object" !== s) return new l("Invalid " + o + " `" + i + "` of type `" + s + "` supplied to `" + r + "`, expected `object`.");

            for (var c in e) {
              var f = e[c];

              if (f) {
                var p = f(u, c, r, o, i + "." + c, a);
                if (p) return p;
              }
            }

            return null;
          }

          return f(t);
        }

        function g(t) {
          switch (_typeof(t)) {
            case "number":
            case "string":
            case "undefined":
              return !0;

            case "boolean":
              return !t;

            case "object":
              if (Array.isArray(t)) return t.every(g);
              if (null === t || e(t)) return !0;
              var n = s(t);
              if (!n) return !1;
              var r,
                  o = n.call(t);

              if (n !== t.entries) {
                for (; !(r = o.next()).done;) {
                  if (!g(r.value)) return !1;
                }
              } else for (; !(r = o.next()).done;) {
                var i = r.value;
                if (i && !g(i[1])) return !1;
              }

              return !0;

            default:
              return !1;
          }
        }

        function w(e, t) {
          return "symbol" === e || "Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol;
        }

        function b(e) {
          var t = _typeof(e);

          return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : w(t, e) ? "symbol" : t;
        }

        function V(e) {
          var t = b(e);

          if ("object" === t) {
            if (e instanceof Date) return "date";
            if (e instanceof RegExp) return "regexp";
          }

          return t;
        }

        function T(e) {
          return e.constructor && e.constructor.name ? e.constructor.name : E;
        }

        var x = "function" == typeof Symbol && Symbol.iterator,
            O = "@@iterator",
            E = "<<anonymous>>",
            N = {
          array: p("array"),
          bool: p("boolean"),
          func: p("function"),
          number: p("number"),
          object: p("object"),
          string: p("string"),
          symbol: p("symbol"),
          any: function () {
            return f(r.thatReturnsNull);
          }(),
          arrayOf: h,
          element: function () {
            function t(t, n, r, o, i) {
              var a = t[n];

              if (!e(a)) {
                return new l("Invalid " + o + " `" + i + "` of type `" + b(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
              }

              return null;
            }

            return f(t);
          }(),
          instanceOf: d,
          node: function () {
            function e(e, t, n, r, o) {
              return g(e[t]) ? null : new l("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
            }

            return f(e);
          }(),
          objectOf: y,
          oneOf: v,
          oneOfType: m,
          shape: _
        };
        return l.prototype = Error.prototype, N.checkPropTypes = u, N.PropTypes = N, N;
      };
    }).call(t, n(0));
  }]);
});